import type { SalesOrder } from '@/lib/services/sales-orders/sales-orders.types'
import { SalesOrderRefundStatus } from '@/lib/enums/SalesOrderRefundStatus'
import { cn } from '@/lib/utils'
import { Badge, type BadgeProps } from '../ui/badge'
import { DynamicIcon } from '../ui/DynamicIcon'

type OrderRefundStatusBadgeProps = {
  status?: SalesOrder['refund_status']
  size?: BadgeProps['size']
  onClick?: BadgeProps['onClick']
  className?: string
}

function OrderRefundStatusBadge(props: OrderRefundStatusBadgeProps) {
  const { status, size = 'md', onClick = undefined, className = '' } = props

  const refundStatus = Object.values(SalesOrderRefundStatus).find(
    (statusItem) => statusItem.Value === status
  )

  if (!refundStatus) {
    return null
  }

  return (
    <Badge variant={refundStatus.Variant} size={size} className={cn(className)} onClick={onClick}>
      <DynamicIcon
        iconName={refundStatus.Icon}
        className={cn(size === 'sm' ? 'size-3' : 'size-4')}
      />

      {refundStatus.Name}
    </Badge>
  )
}

export default OrderRefundStatusBadge
